import { css } from 'lit';
export default css `
  :host {
    --private-container-size-default: 64px;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--private-container-size, var(--private-container-size-default));
    height: var(--private-container-size, var(--private-container-size-default));
    background-color: var(
      --amityeko-icon-badge-bg-color,
      var(--private-bg-color, var(--amityeko-color-gray-8))
    );
    border-radius: 50%;
  }
`;
//# sourceMappingURL=styles.js.map